import { Navigate, Route, Routes } from "react-router-dom";
import { DeveloperDoc, DevelopersIndex } from "./pages/developers/Developers";
import Layout from "./components/Layout";
import Landing from "./pages/Landing";
import Features from "./pages/Features";
import Pricing from "./pages/Pricing";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Privacy from "./pages/Privacy";
import Terms from "./pages/Terms";
import Integrations from "./pages/Integrations";
import Security from "./pages/Security";
import Customers from "./pages/Customers";
import Solutions from "./pages/Solutions";
import SolutionDtc from "./pages/solutions/Dtc";
import SolutionB2b from "./pages/solutions/B2b";
import SolutionMarketplaces from "./pages/solutions/Marketplaces";
import SolutionSubscription from "./pages/solutions/Subscription";
import NotFound from "./pages/NotFound";

export default function App() {
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route index element={<Landing />} />
        <Route path="features" element={<Features />} />
        <Route path="solutions" element={<Solutions />} />
        <Route path="solutions/dtc" element={<SolutionDtc />} />
        <Route path="solutions/b2b" element={<SolutionB2b />} />
        <Route path="solutions/marketplaces" element={<SolutionMarketplaces />} />
        <Route path="solutions/subscription" element={<SolutionSubscription />} />
        <Route path="integrations" element={<Integrations />} />
        <Route path="security" element={<Security />} />
        <Route path="customers" element={<Customers />} />
        <Route path="pricing" element={<Pricing />} />
        <Route path="about" element={<About />} />
        <Route path="contact" element={<Contact />} />
        <Route path="book-a-demo" element={<Navigate to="/contact" replace />} />
        <Route path="privacy" element={<Privacy />} />
        <Route path="terms" element={<Terms />} />
        <Route path="developers" element={<DevelopersIndex />} />
        <Route path="developers/:slug" element={<DeveloperDoc />} />
        <Route path="*" element={<NotFound />} />
      </Route>
    </Routes>
  );
}
